import './styles/aui.pattern.forms';
import '@atlassian/aui/src/css-vendor/jquery/plugins/jquery.select2.css';
import '@atlassian/aui/src/less/aui-select2.less';
import '@atlassian/aui/src/js/aui/select2.js';
export {};
